import { useEffect, useState } from 'react'
import API, { ResourceNotFoundError } from 'service/api'
import Util from 'service/util'
import { getFileExtensionFromMime } from 'service/file-util'
import moment from 'moment'

const getFileName = (mime_type, wa_id) =>
{
  const timestamp = moment().format('YYYY-MM-DD__HHmm')
  const ext = getFileExtensionFromMime(mime_type)
  return `天記訊息-${wa_id}-${timestamp}${ext}`
}


const DocumentMessage = ({
  message
}) =>
{
  const [media, setMedia] = useState(message.media)

  useEffect(() => {
    // update refresh target to the latest component
    message.setMedia = setMedia
  }, [])

  const filename = getFileName(message.mime_type, message.wa_id)

  const onClickDownload = () =>
  {
    if (!media)
    {
      API.getMessageMedia(message.wa_id, message.seq).then(async resp => {
        const objUrl = URL.createObjectURL(await resp.blob())
        message.media = objUrl
  
        // delay re-rendering if it is not ready
        if (!message.setMedia)
        {
          setTimeout(() => message.setMedia(objUrl), 1000)
        }
        else
        {
          message.setMedia(objUrl)
          Util.downloadFromObjectUrl(media, '天記')
        }
        delete message.setMedia
      }).catch(error => {
        if (error instanceof ResourceNotFoundError)
        {
          setMedia('error')
          return
        }
        throw error
      })
    } else {
      // download
      Util.downloadFromObjectUrl(media, filename)
    }
  }

  return (
    <div className="document-message" data-type={message.mime_type}>
      <div>檔案：{ filename }</div>
      <button className="btn btn-small blue" onClick={onClickDownload}>下載</button>
    </div>
  )
}

export default DocumentMessage
